// TODO: until Statistics become module
export const StatisticsTheme = {
  Visible: "visible",
  Hidden: "hidden",
};
